import CloseAccountModal from 'components/GlobalModals/CloseAccountModal/CloseAccountModal';
import { withCloseAccountModalProps } from 'viewModel/globalModals/closeAccountModal/withCloseAccountModalProps';

export default withCloseAccountModalProps(CloseAccountModal);
